import { getCurrentUser, signIn, confirmSignIn } from 'aws-amplify/auth';
import { persistLocalSession } from '@/features/auth/lib/session';

export async function signInWithPassword({ email, password }) {
  const { nextStep } = await signIn({ username: email, password });
  if (nextStep.signInStep === 'CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED') {
    await confirmSignIn({ challengeResponse: password });
  }
  const { userId } = await getCurrentUser();
  persistLocalSession({ userId, email });
  return userId;
}
